import type { Partner } from "@expert/shared-types";
import type { Query } from "@tanstack/react-query";

import { QueryCache, QueryClient } from "@tanstack/react-query";

import { emitExpertHubError, EXPERT_HUB_ACTIONS, type ExpertHubAction } from "@/expert-hub/data/expertHubErrorMetric";

export const CUSTOMER_DETAILS_QUERY_KEY = "customer-details";

const HUB_ERROR_ACTIONS = new Set<string>(Object.values(EXPERT_HUB_ACTIONS));

/**
 * `QueryCache.onError` handler: for a query opting in via `meta.expertHubErrorAction`, emit that Hub
 * error metric once per settled error, deduped across observers — the right granularity for a
 * fetch-failure alert (see `docs/ui-orchestration-frontend-alerting.md` for why not a per-hook effect).
 * Unknown/typo'd actions are dropped. Exported for unit testing.
 */
export function emitHubErrorFromQuery(_error: unknown, query: Pick<Query, "meta">): void {
    const action = query.meta?.expertHubErrorAction;
    if (typeof action === "string" && HUB_ERROR_ACTIONS.has(action)) {
        emitExpertHubError(action as ExpertHubAction, query.meta?.partner as Partner | undefined);
    }
}

export const queryClient = new QueryClient({
    queryCache: new QueryCache({ onError: emitHubErrorFromQuery }),
    defaultOptions: {
        queries: {
            gcTime: 1000 * 60 * 60,
        },
    },
});

export const clearCustomerDetailsQueries = (): void => {
    queryClient.removeQueries({ queryKey: [CUSTOMER_DETAILS_QUERY_KEY], exact: false });
};
